import { Component } from 'react'
import { Box, Button, Flex, Text } from '@chakra-ui/react'

/**
 * Last-resort boundary for render errors outside the router's own error
 * handling (providers, the shell itself). Route-level failures are handled by
 * routes/RouteError.jsx, which keeps the shell mounted.
 */
export class AppErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Unhandled application error', error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <Flex minHeight="100dvh" align="center" justify="center" padding="6" bg="bg.canvas">
        <Box layerStyle="card" padding="6" maxWidth="md" textAlign="center">
          <Text textStyle="cardTitle">The application stopped unexpectedly</Text>
          <Text textStyle="bodySecondary" marginTop="2">
            Reloading usually clears this. If it keeps happening, contact your administrator.
          </Text>
          <Button marginTop="5" size="sm" variant="solid" onClick={this.handleReload}>
            Reload page
          </Button>
        </Box>
      </Flex>
    )
  }
}
